import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import {
  engagementAttemptsLabels,
  engagementAttemptsValues,
} from 'infrastructure/hooks/patient-engagement-report/constants';

import type { TEngagementAttemptsValue } from 'infrastructure/hooks/patient-engagement-report/types';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<TEngagementAttemptsValue>[];

type IEngagementAttemptsSelectBoxProps = Omit<
  IBaseSelectBoxProps<TEngagementAttemptsValue>,
  'options'
>;

/**
 * Single-select over the 14 Monday engagement-attempts options. Reuses the
 * report's own `engagementAttemptsValues` (order) and `engagementAttemptsLabels`
 * (i18n) so the filter, table column, and donut stay in lockstep.
 */
const EngagementAttemptsSelectBox: React.FC<
  IEngagementAttemptsSelectBoxProps
> = (props) => {
  const options: Options = useMemo(
    () =>
      engagementAttemptsValues.map((value) => ({
        value,
        label: engagementAttemptsLabels[value],
      })),
    [],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default EngagementAttemptsSelectBox;
